// Helper function to determine status based on endDate
export const getStatus = (endDate) => {
  if (!endDate) return 'Active';
  const today = new Date();
  const end = new Date(endDate);
  return today > end ? 'Expired' : 'Active';
};

